import React from 'react';
import i18n from '../../translations/i18n';

const BULLETINS_PT = [
    {
        name: 'Boletim Tributário – Agosto/Setembro 2026',
        description: 'Confira a nova edição do nosso Boletim Tributário e fique por dentro das novidades do Poder Executivo, Reforma Tributária, Projetos de Lei, STF, STJ e CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-nosso-boletim-tribut%C3%A1rio-activity-7508209992739766272-_8GL'
    },
    {
        name: 'Boletim Tributário – Junho/Julho 2026',
        description: 'Confira o nosso Boletim Tributário e fique por dentro das novidades do Poder Executivo, Reforma Tributária, Projetos de Lei, STF, STJ e CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-nosso-boletim-tribut%C3%A1rio-e-fique-activity-7483568181773783041-1-gO'
    },
    {
        name: 'Boletim de Infraestrutura – Junho/2026',
        description: 'Fique por dentro do primeiro leilão brasileiro de baterias, atualizações sobre concessões de saneamento em diversas regiões brasileiras e a recém-aprovada Política Nacional dos Minerais Críticos e Estratégicos.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_vem-com-a-gente-e-fique-por-dentro-do-primeiro-activity-7472241542921986048-FVro'
    }
];

const BULLETINS_EN = [
    {
        name: 'Tax Newsletter – August/September 2026',
        description: 'Check out the new edition of our Tax Newsletter and stay up to date with the latest from the Executive Branch, Tax Reform, Bills, STF, STJ and CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-a-nova-edi%C3%A7%C3%A3o-do-nosso-boletim-tribut%C3%A1rio-activity-7508209992739766272-_8GL'
    },
    {
        name: 'Tax Newsletter – June/July 2026',
        description: 'Check out our Tax Newsletter and stay up to date with the latest from the Executive Branch, Tax Reform, Bills, STF, STJ and CARF.',
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_confira-o-nosso-boletim-tribut%C3%A1rio-e-fique-activity-7483568181773783041-1-gO'
    },
    {
        name: 'Infrastructure Newsletter – June/2026',
        description: "Stay up to date on Brazil's first battery auction, updates on sanitation concessions across various Brazilian regions, and the recently enacted National Policy on Critical and Strategic Minerals.",
        link: 'https://www.linkedin.com/posts/barros-pimentel-alcantara-gil-e-rodriguez-advogados_vem-com-a-gente-e-fique-por-dentro-do-primeiro-activity-7472241542921986048-FVro'
    }
];

const Bulletin = ({ bulletins, setBulletins, showModal, setShowModal }) => {
    const data = i18n.language === 'en' ? BULLETINS_EN : BULLETINS_PT;

    React.useEffect(() => {
        setBulletins(data);
    }, [i18n.language]);

    return (
        <div className="boxartigos" id="bulletin-mCustomScrollbar">
            {data.map((item, index) => (
                <a onClick={() => { setShowModal('bulletin', `#bulletin-${index}`) }} key={index}>{item.name}</a>
            ))}
        </div>
    );
};

export { BULLETINS_PT, BULLETINS_EN };
export default Bulletin;
